import { render, staticRenderFns } from "./popup-open-shou-kuan.vue?vue&type=template&id=209caefc&scoped=true"
import script from "./popup-open-shou-kuan.vue?vue&type=script&lang=js"
export * from "./popup-open-shou-kuan.vue?vue&type=script&lang=js"
import style0 from "./popup-open-shou-kuan.vue?vue&type=style&index=0&id=209caefc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209caefc",
  null
  
)

export default component.exports